import { BenefitLayout } from "providers/benefit-layout";
import { CreditMonitoringContent } from "./CreditMonitoringContent";

export { CreditMonitoringContent };

export const CreditMonitoringView = () => {
  return (
    <BenefitLayout
      title="Credit monitoring"
      titleClassName="text-center text-2xl font-bold py-4"
      hasBack
    >
      <CreditMonitoringContent />
    </BenefitLayout>
  );
};
